import React, { useEffect } from 'react'
import Hero from '../components/ourApproach/Hero'
import OurWays from '../components/ourApproach/OurWays'
import SustainableEvents from '../components/ourApproach/SustainableEvents'

const OurApproach = () => {

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])
  
  return (
    <div  className='h-fit w-[100vw] lg:w-full overflow-x-hidden'>
        <Hero />
        <OurWays />
        <SustainableEvents />
    </div>
  )
}

export default OurApproach
